import {AiImageTooltipText} from '@Panels/ai-image-tooltip-text/ai-image-tooltip-text';
import type {ReactElement} from 'react';

export function getTooltipContentForAIImage(prompt: string): ReactElement {
  return <AiImageTooltipText prompt={prompt} />;
}
